import { Row, Col, Card } from "reactstrap";
import { Progressbar } from "../../../../AbstractElements";
import { MultipleBars } from "../../../../Constant";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { MULTIPLE_DATA, MULTIPLE_LIST } from "../../../../Data/UiKit/Progress/index";

export const MultipleBarsCart = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={MultipleBars} span={MULTIPLE_DATA} />
        <Row className="card-body progress-showcase mb-4">
          <Col>
            <Progressbar multi>
              <Progressbar color="primary" bar value="30" />
              <Progressbar color="secondary" bar value="20" />
              <Progressbar color="success" bar value="15" />
            </Progressbar>
            <Progressbar multi>
              {MULTIPLE_LIST.map(({ color, value }, index) => (
                <Progressbar color={color} bar value={value} key={index} />
              ))}
            </Progressbar>
          </Col>
        </Row>
      </Card> 
    </Col>
  );
};
